import { ScreenshotThumbnail } from '../ThreatTable/ThreatExpandedRow.style';
import { ScreenshotThumb } from '../Screenshot';

interface ExpandedScreenshotProps {
  /** Wheel threat_id = Screenshot Collector asset_id (WHEEL-394). */
  threatId?: number;
  /** Fetch only while the row is expanded. */
  enabled?: boolean;
  testId?: string;
}

const ExpandedScreenshot = ({
  threatId,
  enabled = true,
  testId = 'expanded-screenshot',
}: ExpandedScreenshotProps) => (
  <ScreenshotThumbnail>
    <ScreenshotThumb
      threatId={threatId}
      enabled={enabled}
      width={200}
      testId={testId}
    />
  </ScreenshotThumbnail>
);

export default ExpandedScreenshot;
